import { render, staticRenderFns } from "./addRecentWork.vue?vue&type=template&id=1a38ef6c&scoped=true&"
import script from "./addRecentWork.vue?vue&type=script&lang=js&"
export * from "./addRecentWork.vue?vue&type=script&lang=js&"
import style0 from "./addRecentWork.vue?vue&type=style&index=0&id=1a38ef6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38ef6c",
  null
  
)

export default component.exports